import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, input } from '@angular/core';

import { CamAddEventRequest } from '@camelot/calendar';
import { CamBaseModal } from '@camelot/utils';

import { IEvent } from '../../../types/event';

export type CamPlanningEditEventDataTeplate = {
  event?: IEvent;
  preset?: CamAddEventRequest;
};

@Component({
  selector: 'cam-planning-edit-event-content',
  imports: [NgTemplateOutlet],
  templateUrl: './event.component.html',
})
export class CamPlanningEditEventContent extends CamBaseModal<CamPlanningEditEventDataTeplate, null> {
  template = input<TemplateRef<unknown>>();
}
